<div class="content" role="main">


  <img src="assets/kadeck_main_355.png" alt="Logo of KaDeck"  style="width: 100px;margin-bottom: 0;"/>
  <!-- Highlight Card -->
<h1>Xeotek KaDeck</h1>
  <span class="subtopic">
    The correct and fastest way to build applications for Apache Kafka.
  </span>


  <p class="slogan">The relief when everything is organized and under control: for developers, business users and application operations.</p>
<h2>Learn more about Xeotek KaDeck</h2>
  <a class="card" target="_blank" rel="noopener" href="https://www.xeotek.com/kadeck">
    <mat-icon style="margin-right: 10px">home</mat-icon>

    <span>KaDeck Website</span>

    <svg class="material-icons" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
    </svg>
  </a>

  <app-onboarding></app-onboarding>
</div>
